import { Component, NgZone, OnInit, inject } from '@angular/core';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { Store } from '@ngxs/store';
import { UpdatePageTitle } from '../../../../store/app/app.actions';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { WINDOW } from '../../../../_services/window.service';

@Component({
  selector: 'app-help-desk',
  imports: [HeaderComponent, RouterOutlet, LoaderComponent],
  templateUrl: './help-desk.component.html',
})
export class HelpDeskComponent implements OnInit {
  readonly store = inject(Store);
  readonly ngZone = inject(NgZone);
  readonly window = inject<Document>(WINDOW);

  constructor() {
    this.store.dispatch(new UpdatePageTitle('Help Desk'));
  }

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      this.window.location.href = 'https://byteorbit.atlassian.net/helpcenter/Paystashio/';
    });
  }
}
